import React, { Component } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import ImagePreview from "./ImagePreview";

class PhotoGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items:  this.props.photos,
      currentImage: 0,
      viewerIsOpen: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.photos.length !== this.state.items.length) {
      this.setState({ items: nextProps.photos });
    }
  }

  // onSortEnd = ({ oldIndex, newIndex }) => {
  //   const { items } = this.state;
  //   const updatedItems = arrayMove(items, oldIndex, newIndex);
  //   this.setState({ items: updatedItems }, function() {
  //     this.props.arrangePhotos(this.state.items);
  //   });
  // }

  imageRenderer = ({ index, left, top, key, photo }) => {
    const { 
      deleteImage,
      onSetAsCover,
      onDownloadImage
    } = this.props;

     return <ImagePreview
        key={key}
        direction='row'
        margin={"2px"}
        index={index}
        photo={photo}
        left={left}
        top={top}
        onDeleteImage={deleteImage}
        onSetAsCover={onSetAsCover}
        onDownloadImage={onDownloadImage}
        imageId={photo.id}
        openLightbox={this.openLightbox}
      />
  }

  openLightbox = (index) => {
    this.setState({
      currentImage: index,
      viewerIsOpen: true
    });
  }

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      viewerIsOpen: false
    });
  };

  render() {
    const { 
      items,
      currentImage,
      viewerIsOpen
     } = this.state;

    return (
      <React.Fragment>
        <Gallery photos={items} renderImage={this.imageRenderer} />
        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={this.closeLightbox}>
              <Carousel
                currentIndex={currentImage}
                views={items.map(x => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.title
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </React.Fragment>
    )
  }
}

export default PhotoGallery;